import { Tab } from '../components';
import { Home, UserManagement, UserRoles, Security } from '../pages';

export const getDefaultTabs = () => {
  const defaultTabs: Tab[] = [
    {
      name: 'Home',
      icon: 'home',
      component: <Home />,
    },
    {
      name: 'Settings',
      icon: 'settings',
      component: null,
      subTabs: [
        {
          name: 'Users',
          icon: 'profile',
          component: <UserManagement />,
          requiredPermissions: [
            'view_users',
            'view_groups',
            'view_permissions',
          ],
        },
        {
          name: 'User Roles',
          component: <UserRoles />,
          icon: 'community',
          requiredPermissions: ['view_groups', 'view_permissions'],
        },
        {
          name: 'Security',
          component: <Security />,
          icon: 'security',
          requiredPermissions: [],
        },
      ],
    },
  ];

  return defaultTabs;
};
